import * as React from "react";
import { HealthHistoryInfo } from "../patient-portal/HealthHistoryInfo";
import HealthHistoryInformationItemsList from "./HealthHistoryInformationItemsList";

export default function PatientHealthHistoryInformationPanel({
  title,
  healthHistoryInformation,
}: {
  title: string;
  healthHistoryInformation?: HealthHistoryInfo;
}) {
  return (
    <div className="panel">
      <div className="panel-title h-flex space-between no-wrap">
        <div>{title}</div>
      </div>
      {healthHistoryInformation ? (
        <HealthHistoryInformationItemsList healthHistoryInfo={healthHistoryInformation} />
      ) : (
        <div className="centered">
          <span className="no-information-message">
            {i18n["Page.Patient.FullDetails.Information.NotFilled"]}
          </span>
        </div>
      )}
    </div>
  );
}
